import { render, staticRenderFns } from "./campDetailsData.vue?vue&type=template&id=2d84e9b2&scoped=true&"
import script from "./campDetailsData.vue?vue&type=script&lang=js&"
export * from "./campDetailsData.vue?vue&type=script&lang=js&"
import style0 from "./campDetailsData.vue?vue&type=style&index=0&id=2d84e9b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d84e9b2",
  null
  
)

export default component.exports